import { Component, OnInit } from '@angular/core';
import { TableMode } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { QueryOperand } from 'src/app/components/grid/QueryOperand';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { ExamService } from 'src/app/services/exam-service.service';
import { IFilterParam } from 'src/app/components/grid/IFilterParam';

@Component({
  selector: 'app-essay-exam-log',
  templateUrl: './essay-exam-log.component.html',
  styleUrls: ['./essay-exam-log.component.scss']
})
export class EssayExamLogComponent implements OnInit {

  constructor(private examService: ExamService) { }

  async ngOnInit() {
    const res = await this.examService.getEssayExamLog(this.data.tableParams) as [];
    GridUtil.setClearGridSelection();
    this.data.tableRows = res.slice(1, res.length);
  }
  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [
        {
          fieldName: 'examinationID',
          fieldValue: `${this.examService.selectedExamIds}`,
          queryOperand: QueryOperand['=='],
          static: true
        }
      ],
      sortParam: {
        fieldName: "",
        orderDirection: 0,
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'ExamSchedule ID',
      fieldName: 'examScheduleID',
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Exam Started By',
      fieldName: 'examStartedBy',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Start Date/Time',
      fieldName: 'startDateTime',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    }
  ];

  onRowClick(idx: any) {
    //const examSch = this.data.tableRows[idx] as any;
    //this.examSchService.selectedSchQuestionId = examSch.id;
  }

  async refreshData(tableParams) {
     if (this.examService.selectedExamIds?.[0] && !tableParams.filterParams.find(f => f.fieldName == 'examinationID')) {
      var filter: IFilterParam =
      {
        fieldName: 'examinationID',
        fieldValue: `${this.examService.selectedExamIds?.[0]}`,
        queryOperand: QueryOperand['=='],
        static: true
      }

      tableParams.filterParams.push(filter);
    }
    const res = await this.examService.getEssayExamLog(tableParams) as [];
    this.data.tableRows = res.slice(1, res.length);
  }

}
